export default __webpack_public_path__ + "static/media/chaosmeteor.e09ec504.mpeg";